var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBankCardFull = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 0a4 4 0 0 0-4 4v2h32V4a4 4 0 0 0-4-4zm28 10H0v10a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4z",
  clipRule: "evenodd"
})));
export default SvgBankCardFull;